import React, { useEffect } from 'react';
import { ITab, ITabs } from '../../types/customizer';
import './index.scss';
// import URLs from '../../../../utils/url';
import { REQUIRED_TAB_FIELDS, TABS_TO_AVOID, getRowContent } from '../../../utils/summary';
import { APP_STYLES, DEFAULT_STYLES } from '../../../utils/basic';
import { useRingCustomizerContext } from '../../context/RingCustomizerContext';
import If from "../If";
import { formatSummaryDate } from '../Summary';

type PrintProps = {
  tabs: ITabs;
  product: any;
  image: string;
};


  const PrintSummary = React.forwardRef((props:PrintProps, ref) => {
    const { tabs, product, image } = props;
    const {subpath} = useRingCustomizerContext();

    const imageStr = `${process.env.REACT_APP_ASSET_URL}${image}`;
    let imageURL = `${imageStr}${imageStr.indexOf('?') !== -1 ? '&' : '?'}image_size=1200`;
    const styles = APP_STYLES[subpath] || DEFAULT_STYLES;
    if(!styles.watermarkBrand) {
        imageURL += '&watermark=false'
    }
    if (imageURL.indexOf('watermarkBrand=emblem') !== -1 && subpath !== 'customize') {
        const watermark = styles.watermarkBrand;
        imageURL = imageURL.replace('emblem', watermark);
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      const printButton = document.getElementById('print-btn');

      if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && printButton) {
        event.preventDefault();
        printButton.click();
      }
    };

    useEffect(() => {
      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }, []);

    const REQUIRED_TABS = tabs.filter((tab: ITab) => REQUIRED_TAB_FIELDS.includes(tab.eventKey));
    const ADDITIONAL_TABS = tabs.filter((tab: ITab) => !REQUIRED_TAB_FIELDS.includes(tab.eventKey) && !TABS_TO_AVOID.includes(tab.eventKey));

    return (
      // @ts-ignore
      <div ref={ref} className="print-summary tw-py-10 tw-px-4 tw-text-prussian-blue tw-mx-auto tw-w-[calc(100%-2cm)]">
        <div className="tw-flex tw-justify-center tw-mb-4">
          <img className="tw-h-[285px]" src={imageURL} alt="" />
        </div>
        <If condition={subpath === 'frank-adams'}>
          <p className='tw-text-sm tw-mb-4 tw-font-bold'>Please print this summary and bring it with you to Frank Adams Jewelers. We will verify your finger size and be happy to place your order.</p>
        </If>
        <p>
          {product?.description}
        </p>
        <If condition={!['legacy-touch', 'legacy-touch-dev', 'frank-adams'].includes(subpath)}>
          <div className="tw-mt-3 tw-text-lg tw-font-bold">Required</div>
        </If>
        <div className="print-summary-container tw-mt-3 ml-3">
          <div className="tw-mt-1">
            <p>Magic Number</p>
            <p>{product?.magic_number}</p>
          </div>
          {REQUIRED_TABS.map((tab: ITab, index) =>
            (<React.Fragment key={index}> {getRowContent(tab, index)}</React.Fragment>))
          }
        </div>
        <div className="tw-mt-3 tw-text-lg tw-font-bold">Additional Details</div>
        <div className="print-summary-container tw-mt-3 ml-3">
          <div className="tw-mt-1">
            <p>Style</p>
            <p>{product?.sku}</p>
          </div>
          {ADDITIONAL_TABS.map((tab: ITab, index) =>
            (<React.Fragment key={index}> { getRowContent(tab, index) }</React.Fragment>))
          }
        </div>
        <div className="tw-mt-3 tw-text-lg tw-font-bold">Ship Date</div>
        <div className="print-summary-container tw-mt-3 ml-3">
          {product?.shipping_options?.same_day ? <div className="tw-mt-1">
            <p>Same Day</p>
            <p>{formatSummaryDate(product?.shipping_options?.same_day)}</p>
          </div> : null}
          {product?.shipping_options?.next_day ? <div className="tw-mt-1">
            <p>Next Day</p>
            <p>{formatSummaryDate(product?.shipping_options?.next_day)}</p>
          </div> : null}
          {product?.shipping_options?.rush ? <div className="tw-mt-1">
            <p>Rush</p>
            <p>{formatSummaryDate(product?.shipping_options?.rush)}</p>
          </div> : null}
          {product?.shipping_options?.standard ? <div className="tw-mt-1">
            <p>Standard</p>
            <p>{formatSummaryDate(product?.shipping_options?.standard)}</p>
          </div> : null}
        </div>
        <div className="tw-mt-3 tw-text-lg tw-font-bold">Price Details</div>
        <div className="print-summary-container tw-mt-3 ml-3">
          <div className="tw-mt-1">
            <p>Ring Price</p>
            <p>{product?.price}</p>
          </div>
        </div>
        <div className='tw-ml-3 tw-mt-3 tw-text-xs'>* Contact us if you have any questions, need a rush, or need a ring by a specific date sooner than what's displayed.</div>
        <div className="tw-absolute tw-right-5 tw-mt-20">
          Signature: _________________________
        </div>
      </div>
    );
  });

  export default PrintSummary;